const stats = [
  { value: '+100', label: 'Planejamentos Tributários Realizados' },
  { value: '20+', label: 'Anos de Experiência Somadas' },
  { value: '+R$ 50Mi', label: 'Patrimônio Administrado' },
  { value: '95%', label: 'Clientes Satisfeitos' },
];

const credentials = [
  'Aderimos as normas do CRC (Conselho Regional de Contabilidade)',
  'Parceria com escritórios de advocacia especializados',
  'Equipe multidisciplinar: contadores, advogados e consultores',
  'Atendimento personalizado e sigiloso',
];

export function About() {
  return (
    <section id="sobre" className="py-20 lg:py-28 bg-navy-900 text-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Column: Content */}
          <div>
            <span className="text-gold-400 font-semibold text-sm uppercase tracking-wider">Sobre a Patriar</span>
            <h2 className="text-3xl sm:text-4xl font-bold text-white mt-3 mb-6">
              Especialistas em proteger o que você construiu
            </h2>
            <p className="text-lg text-neutral-300 mb-6 leading-relaxed">
              A Patriar nasceu para atender exclusivamente o mercado de holdings patrimoniais imobiliárias.
            </p>
            <p className="text-neutral-400 mb-6 leading-relaxed">
              Nossa missão é democratizar o acesso a estruturas que, além de proteger bens, entregam eficiência tributária de forma simples e transparente.
            </p>
            <p className="text-neutral-400 mb-8 leading-relaxed">
              Acreditamos que toda família merece segurança, conformidade e tranquilidade para o futuro.
            </p>

            {/* Credentials */}
            <ul className="space-y-3">
              {credentials.map((credential, index) => (
                <li key={index} className="flex items-start gap-3">
                  <svg className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-neutral-300">{credential}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column: Stats */}
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <div key={index} className="bg-navy-800/50 border border-navy-700 rounded-2xl p-6 text-center">
                <div className="text-3xl sm:text-4xl font-bold text-gold-400 mb-2">{stat.value}</div>
                <div className="text-neutral-400 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
